import { StaticImage } from 'gatsby-plugin-image';
import { useMemo } from 'react';

const TecnicoImage = ({ className = '', altFromTitle }) => {
  const isFemale = useMemo(() => Math.random() > 0.5, []);

  const alt = `Recreación de especialista en ${altFromTitle} de Proyectop`;

  return isFemale ? (
    <StaticImage
      className={className}
      src="../images/especialista-cerramientos-proyectop.png"
      alt={alt}
      layout="constrained"
      placeholder="blurred"
      quality={75}
      width={819}
      height={1250}
      priority
      //Netlify Ubuntu image doesn't support avif
      //formats={["auto", "webp", "avif"]}
    />
  ) : (
    <StaticImage
      className={className}
      src="../images/tecnico-cerramientos-proyectop.png"
      alt={alt}
      layout="constrained"
      placeholder="blurred"
      quality={75}
      width={826}
      height={1250}
      priority
      //Netlify Ubuntu image doesn't support avif
      //formats={['auto', 'webp', 'avif']}
    />
  );
};

export default TecnicoImage;
